var map = {
	"./amex.jpg": "jtV2",
	"./begin-enrol.svg": "XwMR",
	"./bin-circle.svg": "hcE+",
	"./cancel.svg": "Qqn5",
	"./capitalindex.svg": "csNX",
	"./check-circle-dark-green-chunky.svg": "lh3x",
	"./check-circle-green-chunky.svg": "LC7+",
	"./check-circle-green.svg": "man2",
	"./check-green.svg": "dRdQ",
	"./check.svg": "zx+H",
	"./chevron.svg": "sRcJ",
	"./cieurope.svg": "FVFL",
	"./close.svg": "U4zc",
	"./download-file.svg": "6EvK",
	"./edit-circle.svg": "Oylt",
	"./eye-filled.svg": "Zdf/",
	"./eye.svg": "Miz0",
	"./flag.svg": "9UjI",
	"./flags.png": "Zufj",
	"./flags/1x1/fr.svg": "OKyI",
	"./flags/1x1/gb.svg": "H9bH",
	"./flags/1x1/it.svg": "TM0E",
	"./flags/1x1/tr.svg": "7UUf",
	"./flags/4x3/fr.svg": "6n0y",
	"./flags/4x3/gb.svg": "MsNM",
	"./flags/4x3/it.svg": "dyO8",
	"./flags/4x3/tr.svg": "dlOX",
	"./flags@2x.png": "oUaZ",
	"./forexcfds.svg": "8iFt",
	"./hantec.svg": "m0qV",
	"./intertrader.svg": "chHN",
	"./kapitalindeks.svg": "Gd2W",
	"./loader-white.svg": "XAEA",
	"./loader.svg": "LsH+",
	"./lock.svg": "WXky",
	"./logo.png": "AtYS",
	"./logo.svg": "IUgW",
	"./mail-settings-instruction.png": "Wmp8",
	"./mail.svg": "G10h",
	"./markets.svg": "vLwY",
	"./mastercard.jpg": "AjYB",
	"./n-box.svg": "vNCF",
	"./pen-circle.svg": "zZwA",
	"./pen.svg": "Q68q",
	"./phone.svg": "V8JJ",
	"./photo.svg": "LEWD",
	"./play-hollow.svg": "NhVm",
	"./profile-default.svg": "n6qg",
	"./subscription-example.svg": "N14W",
	"./subscriptions/fxlegacy.svg": "a+e5",
	"./subscriptions/learnforex.svg": "U7RX",
	"./subscriptions/lite.svg": "e6cO",
	"./subscriptions/partnerprogramme.svg": "BrMf",
	"./subscriptions/sal.svg": "Mnu6",
	"./subscriptions/stock.svg": "HoRG",
	"./success-sign.svg": "Be+L",
	"./thinkmarkets.svg": "24Lx",
	"./visa.jpg": "a9ah",
	"./warning.svg": "sex0"
};
function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(__webpack_require__);
};
function webpackAsyncContextResolve(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncatched exception popping up in devtools
	return Promise.resolve().then(function() {
		var id = map[req];
		if(!(id + 1)) // check for number or string
			throw new Error("Cannot find module '" + req + "'.");
		return id;
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = "+3HW";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./public/img eager ^\.\/.*$
// module id = +3HW
// module chunks = 5